import * as tslib_1 from "tslib";
import { EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { DatePickerDirective } from 'ng2-date-picker';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
var now = new Date();
var outputFormat = 'DD-MM-YYYY';
var deliveryPickerConfig = {
    dayBtnFormat: 'D',
    closeOnSelectDelay: 0,
    showNearMonthDays: false,
    monthFormat: 'MMMM, YYYY',
    drops: 'down',
    min: moment(new Date()),
    firstDayOfWeek: "mo"
};
var DatePickerComponent = /** @class */ (function () {
    function DatePickerComponent(translate) {
        this.translate = translate;
        this.open = false;
        this.changeHandler = function (date) { };
        this.touchHandler = function () { };
        this.placeholder = '';
        this.format = outputFormat;
        this.valueChanged = new EventEmitter();
    }
    DatePickerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.datePickerConfig = tslib_1.__assign({}, deliveryPickerConfig, { locale: this.translate.currentLang, min: this.minDate, isDayDisabledCallback: function (date) {
                // date.day() === 0 || date.day() === 6 || date.isBefore(now) || date.isBefore(this.getMinimalDate())
                if (_this.availableDeliveryDates.length > 0) {
                    var dateFound = _this.availableDeliveryDates.find(function (availableDate) { return availableDate.isSame(date, 'day'); });
                    return !dateFound;
                }
                else {
                    return date.day() === 0 || date.day() === 6 || date.isBefore(now) || date.isBefore(_this.minDate);
                }
            } });
    };
    DatePickerComponent.prototype.ngOnChanges = function (changes) {
        if (changes && changes.deliverydates && changes.deliverydates.currentValue && changes.deliverydates.currentValue.length > 0) {
            this.datePickerConfig = tslib_1.__assign({}, this.datePickerConfig);
        }
    };
    Object.defineProperty(DatePickerComponent.prototype, "current", {
        get: function () {
            if (this.currentDate && this.currentDate.isValid())
                return this.currentDate.format('L');
            return this.placeholder;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerComponent.prototype, "minDate", {
        // Control Value Accessor Interface
        get: function () {
            if (this.availableDeliveryDates.length > 0) {
                return moment.min(this.availableDeliveryDates);
            }
            return moment(new Date()).add(1, 'days');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePickerComponent.prototype, "availableDeliveryDates", {
        get: function () {
            if (this.deliverydates && this.deliverydates.length > 0) {
                return this.deliverydates.map(function (deliverydate) { return moment(deliverydate, 'YYYY-MM-DD'); });
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    DatePickerComponent.prototype.writeValue = function (date) {
        this.currentDate = moment(date, this.format);
    };
    DatePickerComponent.prototype.registerOnChange = function (cb) {
        this.changeHandler = cb;
    };
    DatePickerComponent.prototype.registerOnTouched = function (cb) {
        this.touchHandler = cb;
    };
    // End Interface
    DatePickerComponent.prototype.changedValue = function (date) {
        if (date) {
            this.changeHandler(date.format(this.format));
            this.valueChanged.emit(true);
        }
    };
    DatePickerComponent.prototype.openedPicker = function () {
        this.touchHandler();
    };
    DatePickerComponent.prototype.closedPicker = function () {
        this.open = false;
    };
    DatePickerComponent.prototype.togglePicker = function () {
        if (this.open) {
            this.datePicker.api.close();
            this.open = false;
        }
        else {
            this.datePicker.api.open();
            this.open = true;
        }
    };
    return DatePickerComponent;
}());
export { DatePickerComponent };
